import { Position } from '../../../shared/types/protocol.ts';
import { TriStateToggle } from '../../components/triStateToggle.tsx';


interface VisualInspectionProps {
    position: Position,
    positionVal: boolean | null | undefined,
    onUpdatePositionValue: (positionNumber: string, value: boolean | null) => void,
    isActive: boolean,
    isViewMode: boolean,
    onPositionFocus: (positionNumber: string) => void,
}

export function VisualInspection({
    position,
    positionVal,
    onUpdatePositionValue,
    isActive,
    isViewMode,
    onPositionFocus,
}: VisualInspectionProps) {

    return (
        <tr
            className={`${isActive && 'highlight--selected'}`}
            onClick={() => onPositionFocus(position.positionNumber)}
        >
            <td>#<b>{`${position.positionNumber}`}</b></td>
            <td>
                <TriStateToggle
                    selection={positionVal}
                    onSelectionChange={selection => onUpdatePositionValue(position.positionNumber, selection)}
                    onFocus={() => onPositionFocus(position.positionNumber)}
                    disabled={isViewMode}
                    trueLabel='OK'
                    falseLabel='NOK'
                />
            </td>
            <td
                colSpan={5}
                title={position.description}
            >
                {position.description}
            </td>
        </tr>
    );
}
